module.exports = __webpack_public_path__ + "img/newPaintingPav6m.ed6eda9c.png";